import { API } from "@/services/api";
import { filesEndpoints } from "@/constant/endpoints";
import { IAPIResponse } from "@/services/api.types";
import { DownloadTokenResponse, UploadDocumentResponse, UploadImageResponse } from "@/types/files.types";

// Note: GET /public/files/{path} and the raw-file branch of GET /documents/{doc_id}/download
// return binary responses (not JSON) and are intentionally NOT modeled here — the backend
// envelope middleware skips non-JSON content types, so there's no IAPIResponse to unwrap.
// Those are consumed via <img src>/window.open with the URL string, not through this layer.

export const uploadImageService = async (file: File): Promise<IAPIResponse<UploadImageResponse>> => {
  const formData = new FormData();
  formData.append("file", file);
  return API.Post<FormData, UploadImageResponse>(filesEndpoints.uploadImage, formData);
};

export const uploadDocumentService = async (file: File): Promise<IAPIResponse<UploadDocumentResponse>> => {
  const formData = new FormData();
  formData.append("file", file);
  return API.Post<FormData, UploadDocumentResponse>(filesEndpoints.uploadDocument, formData);
};

export const getDocumentDownloadTokenService = async (docId: string): Promise<IAPIResponse<DownloadTokenResponse>> => {
  return API.Post<undefined, DownloadTokenResponse>(filesEndpoints.documentDownloadToken(docId));
};
